import { Button } from '@/components/Button';
import { formatDateTimeWithWeekday } from '../lib/scheduledAt';
import MailDialog from './MailDialog';

type CandidateMailSendConfirmDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  recipientCount: number;
  subject: string;
  scheduledAt: Date | null;
  isSending: boolean;
};

export default function CandidateMailSendConfirmDialog({
  open,
  onClose,
  onConfirm,
  recipientCount,
  subject,
  scheduledAt,
  isSending,
}: CandidateMailSendConfirmDialogProps) {
  const scheduledAtLabel = scheduledAt ? formatDateTimeWithWeekday(scheduledAt) : null;
  const rows = [
    { label: '宛先', value: `${recipientCount}名` },
    { label: '件名', value: subject },
    { label: '送信日時', value: scheduledAtLabel ?? '今すぐ' },
  ];

  return (
    <MailDialog
      open={open}
      onClose={onClose}
      title="送信の確認"
      preventClose={isSending}
      footer={
        <>
          <Button type="button" color="secondary" size="md" disabled={isSending} onClick={onClose}>
            キャンセル
          </Button>
          <Button type="button" color="primary" size="md" disabled={isSending} onClick={onConfirm}>
            {scheduledAtLabel ? '予約する' : '送信する'}
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-md">
        <p className="text-body-sm text-main">
          {scheduledAtLabel
            ? `作成したメールを、「${scheduledAtLabel}」に送信しますか？`
            : '作成したメールを今すぐ送信してよろしいですか？'}
        </p>
        <dl className="flex flex-col gap-xxs rounded-sm bg-gray p-md text-body-sm">
          {rows.map((row) => (
            <div key={row.label} className="flex items-start gap-xs">
              <dt className="w-20 shrink-0 text-sub">{row.label}</dt>
              <dd className="min-w-0 break-words text-main">{row.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </MailDialog>
  );
}
